import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlanComparisonComponent } from './plan-comparison.component';
import { FooterModule } from 'src/app/components/footer/footer.module';
import { HeaderModule } from 'src/app/components/header/header.module';
import { ButtonModule } from '@xref/xref-lib';
import { BillingModalModule } from 'src/app/components/billing-modal/billing-modal.module';

@NgModule({
  declarations: [PlanComparisonComponent],
  imports: [CommonModule, FooterModule, HeaderModule, ButtonModule, BillingModalModule],
  exports: [PlanComparisonComponent],
})
export class PlanComparisonModule {}
